"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
// TODO: Remover dependencia dos componentes de tradução

const NewBlockButton = _ref => {
  let onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "new-block-button",
    className: "add-new-block",
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-plus"
  }), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "mobrender.components--mobilization.add-block-content",
    defaultMessage: "Adicionar bloco de conte\xFAdo"
  }));
};
var _default = exports.default = NewBlockButton;